import VyhlasenievZbierkeZakonov from './VyhlasenievZbierkeZakonov';

export default VyhlasenievZbierkeZakonov;
